import React from "react";
import CustomImage from "../CustomImage";
import format from "date-fns/format";
import { formatOrder } from "../../utils/constants";
import classes from "./LatestNews.module.scss";

interface LatestNewsProps {
  latestNews?: Array<any>;
  isLoading?: boolean;
}

const LatestNews: React.FC<LatestNewsProps> = ({ latestNews = [], isLoading }) => {
  if (!isLoading && latestNews.length === 0) {
    return null;
  }

  return (
    <div className={classes["latest-news-container"]}>
      <h2 className={classes["latest-news-heading"]}>Latest News</h2>
      {latestNews.map((news: any, index: number) => (
        <a className={classes["latest-news-card"]} href={`/news/${news.slug}`} key={index}>
          {news.newimageUrl && (
            <div className={classes["latest-news-image"]}>
              <CustomImage src={news.newimageUrl?.imageUrl} alt={news.newimageUrl?.alt} layout="fill" objectFit="fill" />
            </div>
          )}
          <div className={classes["latest-news-body"]}>
            {news.category && <h6 className={classes["latest-news-category"]}>{news.category}</h6>}
            <h5>{news.title}</h5>
            {news.shortDescription && <p className={classes["latest-news-description"]}>{news.shortDescription}</p>}
            <span className={classes["latest-news-date"]}>{format(new Date(news.date), formatOrder)}</span>
          </div>
        </a>
      ))}
    </div>
  );
};

export default LatestNews;
